<template>
  <span :class="['base-badge', `base-badge--${variant}`, `base-badge--${size || 'md'}`]" :style="customStyle">
    <slot></slot>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md' | 'lg';
  backgroundColor?: string;
  color?: string;
}>();

const customStyle = computed(() => {
  const style: Record<string, string> = {};
  if (props.backgroundColor) style.backgroundColor = props.backgroundColor;
  if (props.color) style.color = props.color;
  return style;
});
</script>

<style scoped>
.base-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.6rem;
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-family-mono);
  line-height: 1;
  letter-spacing: 0.02em;
}

.base-badge--default {
  background: #f3f4f6;
  color: #374151;
}

.base-badge--primary {
  background: var(--color-primary-light);
  color: var(--color-primary);
}

.base-badge--success {
  background: #d1fae5;
  color: #065f46;
}

.base-badge--warning {
  background: #fef3c7;
  color: #92400e;
}

.base-badge--error {
  background: #fee2e2;
  color: #991b1b;
}

.base-badge--sm {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
}

.base-badge--md {
  padding: 0.2rem 0.6rem;
  font-size: var(--font-size-xs);
}

.base-badge--lg {
  padding: 0.3rem 0.75rem;
  font-size: var(--font-size-sm);
}
</style>
